export default __webpack_public_path__ + "84686227112a6ce51c14fa9e8c2e80ba.png";